import React, { useContext, useState, useEffect } from 'react';
import { makeStyles, useTheme, withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import AddCircleIcon from '@mui/icons-material/AddCircleOutlined';
import { Paper, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import adminService from "../../services/admin.service";
import { UserContext } from '../../common/UserContext';
import LinearProgress from '@mui/material/LinearProgress';
import MemoItem from './memoItem';
import RouteConstants from "../../common/RouteConstants";
import MemoAddIcon from '@mui/icons-material/PostAdd'
import IconButton from "@mui/material/IconButton";
import { darkenColor } from '../../utils/appHelper';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    searchBox: {
        width: '250px',
        [theme.breakpoints.only('xs')]: {
            width: '200px',
        },
        [theme.breakpoints.down(325)]: {
            width: '165px',
        },
    },
    memoboardContent: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'auto',
        height: 'auto',
    },
    addMemoSection: {
        padding: theme.spacing(1, 2, 0, 2),
        display: 'flex',
        justifyContent: 'flex-end',
    },
    cursorPointer :{
    cursor:'pointer',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 150,
        color: '#fff',
    },
    table: {
        borderRadius: 0,
    },
    addGroup: {
        border: '1px solid #1d428a',
        borderRadius: '4px',
        padding: '6px 8px',
        marginBottom: '10px',
        fontSize: '1rem',
        color: '#fff',
        background: '#1d428a',
        '&:hover': {
          color: '#fff',
          background: '#1d428a',
        },
        '&:focus': {
          color: '#fff',
          background: '#1d428a',
        },
        '& svg': {
          marginRight: '5px',
        },
      },
}));
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 10) : theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);


function UserMemoBoardContainer(props) {
    const classes = useStyles();
    const context = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const [allUserMemos, setAllUserMemos] = useState(null);

    useEffect(() => {
        geAllUserMemos();
    }, []);

    const geAllUserMemos = () => {
        adminService.geAllUserMemos()
            .then(result => {
                if (result) {
                    setAllUserMemos(result.userMemos);
                }
                setLoading(true);
            }).catch((err) => {
            });
    };

    return (
        <div className={classes.root}>
            <div className="repsContainer" style={{ overflow: 'hidden' }}>
                <div className={classes.memoboardContent}>
                    {
                        <React.Fragment>
                            {
                                (!loading) &&
                                <LinearProgress color="secondary"></LinearProgress>
                            }
                        </React.Fragment>
                    }
                    <Grid container>
                        <TableContainer component={Paper} className={classes.table}>
                            <Table size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell style={{ width: '90%' }}>Title</StyledTableCell>
                                        <StyledTableCell align="center" style={{ width: '10%' }}>Action</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {allUserMemos && allUserMemos.map((item, index) => {
                                        return <MemoItem
                                            key={index}
                                            data={item}
                                            onEditClick={null}
                                            onDeleteClick={null}
                                            showEditDeleteButton={false}
                                        />
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </div>
            </div>
        </div>
    );
};

export default UserMemoBoardContainer;